<form
  class="form-inline md-form form-sm form-control form-control-sm px-2 py-2 search-field"
>
  <img
    class="d-inline pointer-cursor"
    src="assets/svg/ico-search.svg"
    (click)="searchThis()"
  />
  <input
    class="field ml-3 w-75"
    type="text"
    [placeholder]="placeholderText"
    aria-label="Search"
    [(ngModel)]="searchWord"
    (input)="searchThis()"
    mdbInput
    id="{{ ID }}"
    [attr.maxlength]="maxLength || null"
    autocomplete="off"
  />
  <img
    *ngIf="searchWord"
    class="d-inline ml-auto mr-auto pointer-cursor"
    src="/assets/svg/ico-cross-grey.svg"
    (click)="clear()"
  />
</form>
